import React from 'react';
import { Tooltip } from 'react-clone-tippy';
import { getTranslatedText, useUserMSPCheckHook } from '@nile/components';
import 'react-clone-tippy/dist/tippy.css';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { TicketDisplayIdContainer } from '.';

function PriorityCell(props) {
  const { cell, intl } = props;
  const isMsp = useUserMSPCheckHook();
  const isSideConversationAvailable = isMsp;
  const data = cell.row.original || cell.row.values;
  const { numberOfUnreadVendorConversation } = data;
  const isTriageTicket = data?.technician?.userId === '14';

  return (
    <>
      <div
        className="flex center full-width position-relative pr5 fx-sb"
        key={cell.value}
      >
        <TicketDisplayIdContainer ticket={data} />
        <div className="fx">
          {isSideConversationAvailable && !!numberOfUnreadVendorConversation && (
            <Tooltip
              html={
                <div>
                  {getTranslatedText(
                    intl,
                    'vendor.replied.ticket.onhover.tooltip'
                  )}
                </div>
              }
              delay={400}
              duration={250}
              position="bottom"
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
            >
              <div className="fx actr ml-10">
                <SVGIcon name="Helpcenter" color="red" size="sm" />
              </div>
            </Tooltip>
          )}
          {cell?.row?.original?.client === null && (
            <Tooltip
              html={
                <div>
                  {getTranslatedText(intl, 'unknown.ticket.onhover.tooltip')}
                </div>
              }
              delay={400}
              duration={250}
              position="bottom"
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
            >
              <div className="fx actr ml-10">
                <SVGIcon name="QuestionMark" color="red" />
              </div>
            </Tooltip>
          )}
          {isMsp && cell?.row?.original?.latestReply?.type === 'REQ_REPLY' && (
            <Tooltip
              html={
                <div>
                  {getTranslatedText(
                    intl,
                    'requester.replied.ticket.onhover.tooltip'
                  )}
                </div>
              }
              delay={400}
              duration={250}
              position="bottom"
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
            >
              <div className="fx actr ml-10">
                <SVGIcon name="IncomingMail" color="red" size="sm" />
              </div>
            </Tooltip>
          )}

          {isMsp && isTriageTicket && (
            <Tooltip
              html={
                <div>
                  {getTranslatedText(
                    intl,
                    'ticket.subject.triage.agent.icon.tooltip.message'
                  )}
                </div>
              }
              delay={400}
              duration={250}
              position="bottom"
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
            >
              <div className="fx actr ml-10">
                <SVGIcon name="AISparkleAnimated" />
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    </>
  );
}

export default React.memo(injectIntl(PriorityCell));
